import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getWorksServicePaymentRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,dtConfig[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].getWorksServicePaymentRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getBaseWorksServicePaymentRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,dtConfig[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].getBaseWorksServicePaymentRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getExtendedWorksServicePaymentRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,dtConfig[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].getExtendedWorksServicePaymentRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function createWorksServicePaymentRateNorm(companyId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,dtConfig[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].createWorksServicePaymentRateNorm,
		{
			urlParams: {
				companyId,
			},
			...data,
		},
	)
}

function getWorksServicePaymentRateNorm(companyId, worksServicePaymentRateNormId) {
	
	return dataTransferWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,dtConfig[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].getWorksServicePaymentRateNorm,
		{
			urlParams: {
				companyId,
				worksServicePaymentRateNormId,
			},
		},
	)
}

function patchWorksServicePaymentRateNorm(companyId, worksServicePaymentRateNormId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,dtConfig[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].patchWorksServicePaymentRateNorm,
		{
			urlParams: {
				companyId,
				worksServicePaymentRateNormId,
			},
			...data,
		},
	)
}

function putWorksServicePaymentRateNorm(companyId, worksServicePaymentRateNormId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,dtConfig[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].putWorksServicePaymentRateNorm,
		{
			urlParams: {
				companyId,
				worksServicePaymentRateNormId,
			},
			...data,
		},
	)
}

function deleteWorksServicePaymentRateNorm(companyId, worksServicePaymentRateNormId) {
	return dataTransferWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,dtConfig[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].deleteWorksServicePaymentRateNorm,
		{
			urlParams: {
				companyId,
				worksServicePaymentRateNormId,
			},
		},
	)
}

export default {
	getWorksServicePaymentRateNorms,
	getBaseWorksServicePaymentRateNorms,
	getExtendedWorksServicePaymentRateNorms,
	getWorksServicePaymentRateNorm,
	patchWorksServicePaymentRateNorm,
	putWorksServicePaymentRateNorm,
	createWorksServicePaymentRateNorm,
	deleteWorksServicePaymentRateNorm,
}